import React from "react";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import logoTransmex from "../../assets/TransMexLogo-Final_CMYK.png";
import logoSwift from "../../assets/swift_Logo.png";
import "./Home.css";

export default function Home() {
  const { t } = useTranslation();
  
  // Obtener idEmpresa del localStorage
  const idEmpresa = localStorage.getItem('empresa');
  
  // Determinar logo según idEmpresa (TransMex por default, Swift solo para idEmpresa = 2)
  const getLogo = () => {
    if (idEmpresa === '2') {
      // console.log('Home - Retornando logo Swift:', logoSwift);
      return logoSwift;
    } else {
      // console.log('Home - Retornando logo TransMex:', logoTransmex);
      return logoTransmex;
    }
  };
  
  return (
    <div className="container-home">
      <Box
        component="img"
        sx={{
          height: 135,
          width: 583,
        }}
        alt={t("home.logoAlt")}
        src={getLogo()}
      />
    </div>
  );
}
